var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{attrs:{"elevation":"1"}},[_c('v-skeleton-loader',_vm._b({},'v-skeleton-loader',_setup.attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }